import { Children, cloneElement, forwardRef, useState } from 'react';

import DialogActions from '@mui/material/DialogActions';
import { usePickerContext } from '@mui/x-date-pickers/hooks';
import { PickersActionBar } from '@mui/x-date-pickers/PickersActionBar';

const ActionBarRoot = forwardRef(function ActionBarRoot({ children, onCancel, ...props }, ref) {
  return (
    <DialogActions {...props} ref={ref}>
      {Children.map(children, child => (child?.key === 'cancel' ? cloneElement(child, { onClick: onCancel }) : child))}
    </DialogActions>
  );
});

export default function OpeningValuePickerActionBar(props) {
  const { open, setOpen, setValue, value } = usePickerContext();
  // TODO: drop this action bar once MUI's Cancel stops restoring the mount/last-accepted value after the
  // controlled value changes from outside (still the case in 9.15; pickers 7 restored the value at open).
  const [opening, setOpening] = useState({ open, value });
  if (open !== opening.open) {
    setOpening({ open, value: open ? value : opening.value });
  }
  // This Cancel skips the picker's own onCancel prop; no caller uses it.
  const handleCancel = () => {
    setValue(opening.value, { changeImportance: 'set', skipPublicationIfPristine: true, source: 'view' });
    setOpen(false);
  };
  return <PickersActionBar {...props} as={ActionBarRoot} onCancel={handleCancel} />;
}
